export default "/images/vendor/flag-icons/flags/4x3/mk.svg?b5eadefbb6da73c9d0cf06f78087fe71";